import values from 'lodash/values';
import React, { useEffect, useState } from 'react';
import MLIcon from '../../../../../../components/MLIcon/MLIcon';
import { INSIGHTS_MENU } from '../../../../constants';
import { useViewport } from '../../hooks/useViewport';
import s from './SideNav.module.css';
import { getInsightsTag } from '../../helpers';

export const SideNav = ({ onTabSelect, selectedTab }) => {
  const { isMobile, isDesktop } = useViewport();
  const [isHidden, setIsHidden] = useState(false);

  const toggleHidden = () => setIsHidden((b) => !b);

  useEffect(() => {
    if (!isDesktop) setIsHidden(true);
  }, [isDesktop]);

  return (
    <nav
      className={`${s.sidenav} ${isHidden ? s.hidden : s.open} ${
        isMobile && s.mobileMenu
      }`}
    >
      {isHidden ? (
        <button
          onClick={() => setIsHidden(false)}
          className={s.menuButton}
          data-test-id="Insights-expand-side-menu"
          aria-label="Expand side menu"
        >
          <MLIcon className={s.menuIcon} type="menu" />
        </button>
      ) : (
        <div className={s.menu}>
          <button
            onClick={toggleHidden}
            className={s.hideMenu}
            data-test-id="Insights-hide-side-menu"
          >
            <MLIcon
              className={s.chevron}
              role="presentation"
              type="chevron_left"
            />
            <span>Hide Menu</span>
          </button>

          {values(INSIGHTS_MENU).map((menu) => (
            <button
              key={menu}
              onClick={() => {
                onTabSelect(menu);
                if (isMobile) toggleHidden();
              }}
              className={`${s.navButton} ${
                menu === selectedTab && s.navButtonSelected
              }`}
              data-test-id={getInsightsTag(menu)}
            >
              {menu}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
};
